import template from './manager_search_component.html';

class ManagerSearchComponentViewModel
{
	constructor (params)
	{
		this.params = params;

		this.managers = ko_helper.safe_observableArray();
		this.selected_manager = ko_helper.safe_observable(params.selected_manager || '');
		this.search_string = ko.observable('');
		this.department_id = ko_helper.safe_observable(params.department_id || '');

		// Computed observable for dynamically updating the placeholder
		this.placeholderText = ko.pureComputed(() => {
			return this.selected_manager() ? 
				`${this.selected_manager().firstname} ${this.selected_manager().surname}` : 
				"Search manager";
		});

		this.search_string.subscribe((newValue) => {
			this.updateData();
		});
	}

	async init()
	{
		await this.updateData();
	}

	async updateData()
	{
		let options = {
			table: 'v_manager_department',
			schema: 'savanna',
			limit: 1000000,
			filter_join: 'OR',
			filter: [],
			fields: ['id_number', 'firstname', 'surname', 'employee_id', 'email', 'department_id', 'company', 'department']
		};

		if (this.search_string() && this.search_string() != '')
		{
			options.filter.push({
				field: 'firstname',
				operand: 'ILIKE',
				value: `%${this.search_string()}%`,
			});

			options.filter.push({
				field: 'surname',
				operand: 'ILIKE',
				value: `%${this.search_string()}%`,
			});

			let result = await Grape.fetches.getJSON('/api/record', options);

			if (result.status != 'ERROR')
			{
				if (result.records != null)
				{
					if (this.department_id() != '')
					{
						let filtered_managers = result.records.filter(d => d.department_id == this.department_id());
						let unique_managers = [];
						let seen_ids = new Set();

						for (let mgr of filtered_managers) {
							if (!seen_ids.has(mgr.employee_id)) {
								seen_ids.add(mgr.employee_id);
								unique_managers.push(mgr);
							}
						}
						this.managers(unique_managers);
					}
					else {
						let unique_managers = [];
						let seen_ids = new Set();

						for (let mgr of result.records) {
							if (!seen_ids.has(mgr.employee_id)) {
								seen_ids.add(mgr.employee_id);
								unique_managers.push(mgr);
							}
						}
						this.managers(unique_managers);
					}

				}
			}
		}
		else
			this.managers([]);
	}

	manager_click (selected)
	{
		this.selected_manager(selected);
		this.search_string('');
	}

	clear_selected_option ()
	{
		this.selected_manager(null);
		this.search_string('');
	}
}

export default {
	name: 'manager_search_component',
	viewModel: ManagerSearchComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/manager_search_component'
};
